<template>
  <footer class="footer">
    <div class="footer__replic">
      <BaseIconButton
        icon="replic"
        :is-active="Boolean(replic)"
        disabled
      />
      <div
        v-if="replic"
        class="footer__text"
        data-animation="fadeInLeft"
      >
        <BaseText
          :text="replic"
          :size="replicTextSize"
        />
      </div>
    </div>
    <div class="footer__actions">
      <BaseIconButton
        icon="mute"
        @click="abortReplic"
      />
    </div>
  </footer>
</template>

<script>
import BaseIconButton from '@/components/BaseIconButton.vue';
import BaseText from '@/components/BaseText.vue';

import CONSTANTS from '@/helpers/constants';

const {
  ACTION_VOLUME_UP,
  ACTION_VOLUME_DOWN,
  USER_REPLIC,
} = CONSTANTS;

const VOLUME_STEP = 20;

export default {
  name: 'TheFooter',
  components: {
    BaseIconButton,
    BaseText,
  },
  data() {
    return {
      volume: 0,
      replic: '',
    };
  },
  staticData: () => ({
    replicTimeout: null,
  }),
  computed: {
    replicTextSize() {
      if (this.replic.length < 100) return '';
      if (this.replic.length < 250) return 's';
      return 'xs';
    },
  },
  created() {
    this.getVolume();
    this.initActions();
  },
  methods: {
    setVolume(volume) {
      this.volume = Number(volume);
      this.$robot.settingsService.setVolume(this.volume);
    },
    setVolumeUp() {
      const up = this.volume + VOLUME_STEP;
      const volume = up <= 100 ? up : 100;
      this.setVolume(volume);
    },
    setVolumeDown() {
      const down = this.volume - VOLUME_STEP;
      const volume = down >= 0 ? down : 0;
      this.setVolume(volume);
    },
    async getVolume() {
      try {
        this.volume = await this.$robot.settingsService.getVolume();
      } catch (e) {
        console.error('settingsService.getVolume error: ', e);
      }
    },
    abortReplic() {
      return this.$robot.dialogService.abortRobotReplic();
    },
    setReplic(text) {
      this.replic = text;
    },
    sayAnswer(answer) {
      this.$robot.dialogService.sayAnswerByData(answer, true);
    },
    onRobotReplic(text) {
      this.setReplic(text);
      this.clearReplicTimeout();
    },
    onUserReplic(text, isFinish) {
      this.setReplic(text);
      this.clearReplicTimeout();
      if (isFinish) {
        this.replicTimeout = window.setTimeout(this.clearReplic, 1000);
        this.$root.$emit(USER_REPLIC, text);
      }
    },
    clearReplic() {
      this.setReplic('');
    },
    clearReplicTimeout() {
      window.clearTimeout(this.replicTimeout);
    },
    initActions() {
      const robotActions = [
        this.$robot.dialogService.onRobotReplicStart(this.onRobotReplic),
        this.$robot.dialogService.onRobotReplicFinish(this.clearReplic),
        this.$robot.dialogService.onUserReplic(this.onUserReplic),
        this.$robot.dialogService.onLoadAnswer(this.sayAnswer),
      ];
      const rootActions = [
        [ACTION_VOLUME_UP, this.setVolumeUp],
        [ACTION_VOLUME_DOWN, this.setVolumeDown],
      ];

      rootActions.forEach((action) => this.$root.$on(...action));

      this.$once('hook:beforeDestroy', () => {
        rootActions.forEach((action) => this.$root.$off(...action));
        robotActions.forEach((unsubscribe) => unsubscribe());
        this.clearReplicTimeout();
      });
    },
  },
};
</script>

<style lang="stylus">
.footer
  display flex
  align-items center
  padding-left $side_padding
  padding-right @padding-left

  .screen_footer_hidden ~ &
    visibility hidden

  &__replic
    display flex
    align-items center
    max-width calc(100% - 8em)
    pointer-events none

  &__text
    flex-grow 1
    flex-basis 0
    max-width calc(100% - 1.6em)
    padding-left 2em
    padding-right 2em
    .text
      overflow hidden
      text-overflow ellipsis
      display -webkit-box
      -webkit-line-clamp 3
      -webkit-box-orient vertical

  &__actions
    position relative
    margin-left auto
    display flex
    justify-content flex-end
    width 5.4em
</style>
